/**
* @ngdoc directive
* @name Zip Code
*
* @description
  Zip Code input with validation
*
* @scope
* @param {Boolean} optional
*
* @example
  <zip-code ng-init='code="123"' ng-model="code"></zip-code>
*/

(function () {
  zipCode.$inject = ["PATH"];
  app.directive('zipCode', zipCode);

  function zipCode (PATH) {
    var directive = {
      replace: true,
      restrict: 'E',
      require: 'ngModel',
      templateUrl: PATH.components + 'zipCodeDirective/zipCodeDirective.html',
      scope: {
        optional: '=?'
      },
      link: link
    };

    return directive;

    function link (scope, element, attrs, modelCtrl) {
      var nineDigits = /^\d{9}$/;
      var newValue;

      scope.zipPattern = /^\d{5}(-?\d{4})?$/;
      attrs.$set('maxlength', 10);

      element.on('blur', function() {
        if (element.val().match(nineDigits)) {
          newValue = element.val().slice(0, 5) + "-" + element.val().slice(5);
          modelCtrl.$setViewValue(newValue);
          modelCtrl.$render();
        }
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/zipCodeDirective/zipCodeDirective.js